<div *transloco="let t" class="expert-dialog">
	<ng-container>
		<div class="flex flex-col h-full w-full">
			<mat-dialog-content>
				<h3 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('billing.costExpertViewTitle') }}</h3>
				<div [formGroup]="costGroupFg">
					<div class="flex flex-col my-2">
						<div class="flex flex-row">
							<mat-form-field appearance="outline" class="mx-2 w-[50%]">
								<mat-label>{{ t('billing.name') }}</mat-label>
								<input formControlName="name" matInput [matTooltip]="costGroupFg.get('name')?.value ?? ''" />
							</mat-form-field>
							<mat-form-field appearance="outline" class="mx-2 w-[50%]">
								<mat-label>{{ t('common.printName') }}</mat-label>
								<input formControlName="printName" matInput [matTooltip]="costGroupFg.get('printname')?.value ?? ''" />
							</mat-form-field>
						</div>
						<div class="flex flex-row">
							<mat-form-field appearance="outline" class="mx-2 w-full">
								<mat-label>{{ t('billing.description') }}</mat-label>
								<input formControlName="description" matInput />
							</mat-form-field>
						</div>
					</div>
					<div class="flex items-center justify-start w-full">
						<div class="text-black pr-2">
							{{ t('billing.allocation') }}
						</div>
						<hr class="w-full my-4" />
					</div>
					<mat-form-field appearance="outline" class="w-full mx-2">
						<mat-label>{{ t('billing.allocationSelect') }}</mat-label>
						<mat-select formControlName="selectedAllocation" name="selectedOption" class="w-full" panelClass="custom-select-options">
							<mat-select-trigger>
								{{ getAllocationName() }}
								@if (costGroupFg.get('selectedAllocation').value) {
									<mat-icon
										class="mat-select-clear-icon"
										[matTooltip]="t('commonActions.deleteSelection')"
										(click)="$event.stopPropagation(); costGroupFg.get('selectedAllocation').setValue(undefined)">
										clear
									</mat-icon>
								}
							</mat-select-trigger>
							@for (currentAllocation of allocations(); track currentAllocation.exportId) {
								<mat-option [value]="currentAllocation">
									<vex-allocation-option [allocation]="currentAllocation" />
								</mat-option>
							} @empty {
								{{ t('billing.assignAllocationNoData') }} {{ t('billing.allocationDefinition') }}
							}
						</mat-select>
					</mat-form-field>

					<div class="flex items-center justify-start w-full">
						<div class="text-black pr-4 whitespace-nowrap flex-shrink-0">
							{{ t('billing.costType') }}
						</div>
						<hr class="w-full my-4" />
					</div>
					<mat-form-field appearance="outline" class="w-full mx-2">
						<mat-label>{{ t('billing.costTypeSelect') }}</mat-label>
						<mat-select class="w-full" formControlName="selectedCostType" panelClass="!max-h-[32rem] !overflow-y-auto">
							<mat-select-trigger>
								{{ t('billing.costTypes.' + costGroupFg.get('selectedCostType').value) }}
								@if (costGroupFg.get('selectedCostType').value && !costGroupFg.get('selectedCostType').disabled) {
									<mat-icon
										class="mat-select-clear-icon"
										[matTooltip]="t('commonActions.deleteSelection')"
										(click)="$event.stopPropagation(); costGroupFg.get('selectedCostType').setValue(undefined)">
										clear
									</mat-icon>
								}
							</mat-select-trigger>
							@for (costType of costTypeMeta; track costType) {
								<mat-option [value]="costType.costType">
									{{ t('billing.costTypes.' + costType.costType) }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<div class="flex items-center justify-start w-full">
						<div class="text-black pr-4 whitespace-nowrap flex-shrink-0">
							{{ t('billing.bvedCostTypeTitle') }}
						</div>
						<hr class="w-full my-4" />
					</div>
					<mat-form-field appearance="outline" class="w-full mx-2">
						<mat-label>{{ t('billing.bvedCostTypeSelect') }}</mat-label>
						<mat-select class="w-full" formControlName="selectedBvedCostType" panelClass="!max-h-[32rem] !overflow-y-auto">
							<mat-select-trigger>
								{{ t('billing.bvedCostTypes.' + costGroupFg.get('selectedBvedCostType').value) }}
								@if (costGroupFg.get('selectedBvedCostType').value && !costGroupFg.get('selectedBvedCostType').disabled) {
									<mat-icon
										class="mat-select-clear-icon"
										[matTooltip]="t('commonActions.deleteSelection')"
										(click)="$event.stopPropagation(); costGroupFg.get('selectedBvedCostType').setValue(undefined)">
										clear
									</mat-icon>
								}
							</mat-select-trigger>
							@for (bvedCostType of bvedCostTypes(); track bvedCostType) {
								<mat-option [value]="bvedCostType">
									<!-- Erste Zeile: Übersetzung -->
									<div class="flex flex-col py-1">
										<div class="font-bold">
											{{ t('billing.bvedCostTypes.' + bvedCostType) }}
										</div>
										<!-- Zweite Zeile: Key und Kategorie -->
										<div class="font-light">
											Key: {{ getBvedCostTypeKey(bvedCostType) }}, {{ t('billing.category') }}:
											{{ t(getBvedMainCategoryI18nKey(getBvedMainCategory(bvedCostType))) }}
										</div>
									</div>
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<mat-expansion-panel [expanded]="false" class="mt-4">
					<mat-expansion-panel-header style="padding-right: 1rem !important">
						<mat-panel-title class="flex flex-row justify-between items-center w-full">
							{{ t('billing.invoiceAmounts') }}
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div class="flex flex-row justify-start items-start gap-2">
						<div class="w-[50%]">
							{{ t('common.selectedList') }}
							<mat-card>
								<mat-list [disabled]="periodService.selectedPeriod().locked">
									@for (item of selectedInvoiceAmounts(); track item) {
										<mat-list-item>
											<div class="flex flex-row justify-start items-center w-full gap-2 break-all whitespace-normal wrap-anywhere">
												<button mat-raised-button color="primary" class="!min-w-12" (click)="moveInvoiceAmount(item, true)">
													<mat-icon>arrow_forward</mat-icon>
												</button>
												<div [innerHTML]="t('billing.invoiceAmountType.' + item)"></div>
											</div>
										</mat-list-item>
									}
								</mat-list>
							</mat-card>
						</div>
						<div class="w-[50%]">
							{{ t('common.selectableList') }}
							<mat-card>
								<mat-list [disabled]="periodService.selectedPeriod().locked">
									@for (item of selectableInvoiceAmounts(); track item) {
										<mat-list-item>
											<div class="flex flex-row justify-start items-center w-full gap-2 break-all whitespace-normal wrap-anywhere">
												<button mat-raised-button color="accent" class="!min-w-12" (click)="moveInvoiceAmount(item, false)">
													<mat-icon>arrow_backward</mat-icon>
												</button>
												{{ t('billing.invoiceAmountType.' + item) }}
											</div>
										</mat-list-item>
									}
								</mat-list>
							</mat-card>
						</div>
					</div>
				</mat-expansion-panel>
				<hr />
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header style="padding-right: 1rem !important">
						<mat-panel-title class="flex flex-row justify-between items-center w-full">
							{{ t('billing.invoiceCategories') }}
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div class="flex flex-row justify-start items-start gap-2">
						<div class="w-full">
							{{ t('common.selectedList') }}
							<mat-card>
								<mat-list [disabled]="periodService.selectedPeriod().locked">
									@for (item of selectedInvoiceCategories(); track item) {
										<mat-list-item>
											<div class="flex flex-row justify-start items-center w-full gap-2">
												<button mat-raised-button color="primary" (click)="moveInvoiceCategory(item, true)">
													<mat-icon>arrow_forward</mat-icon>
												</button>
												{{ t('enum.' + item) }}
											</div>
										</mat-list-item>
									}
								</mat-list>
							</mat-card>
						</div>
						<div class="w-full">
							{{ t('common.selectableList') }}
							<mat-card>
								<mat-list [disabled]="periodService.selectedPeriod().locked">
									@for (item of selectableInvoiceCategories(); track item) {
										<mat-list-item class="flex flex-row justify-between items-center gap-2">
											<button mat-raised-button color="accent" (click)="moveInvoiceCategory(item, false)">
												<mat-icon>arrow_backward</mat-icon>
											</button>
											<span class="spacer"></span>
											{{ t('enum.' + item) }}
										</mat-list-item>
									}
								</mat-list>
							</mat-card>
						</div>
					</div>
				</mat-expansion-panel>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header style="padding-right: 1rem !important">
						<mat-panel-title class="flex flex-row justify-between items-center w-full">
							{{ t('billing.invoiceDeliveries') }}
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div class="flex flex-row justify-start items-start gap-2">
						<mat-card class="w-full">
							<mat-card-header>
								<div class="flex flex-row items-center justify-start" [formGroup]="deliveryForm">
									<div>
										<mat-form-field appearance="outline">
											<mat-label>{{ t('billing.commodity') }}</mat-label>
											<mat-select formControlName="commodity">
												@for (commodity of commodities(); track commodity.commodity) {
													<mat-option [value]="commodity.commodity">
														{{ t('commodity.' + commodity.commodity) }}
													</mat-option>
												}
											</mat-select>
										</mat-form-field>
									</div>
									<div>
										<mat-form-field appearance="outline">
											<mat-label>{{ t('billing.unit') }}</mat-label>
											<mat-select formControlName="physicalUnit">
												@for (unit of physicalUnits(); track unit) {
													<mat-option [value]="unit.physicalUnit">
														{{ t('enum.' + unit.physicalUnit) }}
													</mat-option>
												}
											</mat-select>
										</mat-form-field>
									</div>

									<div>
										@if (isEditMode) {
											<button (click)="cancelEdit()" mat-raised-button type="button">
												{{ t('commonActions.cancel') }}
											</button>
										}
										<button
											mat-raised-button
											color="primary"
											[disabled]="deliveryForm.invalid || this.periodService.selectedPeriod().locked"
											(click)="saveCommodity()">
											{{ isEditMode ? t('commonActions.save') : t('commonActions.add') }}
										</button>
									</div>
								</div>
							</mat-card-header>

							<mat-card-content>
								<div>
									<table mat-table [dataSource]="deliveries()">
										<!-- Commodity Column -->
										<ng-container matColumnDef="commodity">
											<th mat-header-cell *matHeaderCellDef>{{ t('billing.commodity') }}</th>
											<td mat-cell *matCellDef="let row">
												{{ t('commodity.' + row.commodity) }}
											</td>
										</ng-container>

										<!-- Unit Column -->
										<ng-container matColumnDef="unit">
											<th mat-header-cell *matHeaderCellDef>{{ t('billing.unit') }}</th>
											<td mat-cell *matCellDef="let row">
												{{ t('enum.' + row.physicalUnit) }}
											</td>
										</ng-container>

										<!-- Actions Column -->
										<ng-container matColumnDef="actions">
											<th mat-header-cell *matHeaderCellDef>Aktionen</th>
											<td mat-cell *matCellDef="let row">
												@if (!periodService.selectedPeriod().locked) {
													<button mat-icon-button color="primary" (click)="editCommodity(row)">
														<mat-icon>edit</mat-icon>
													</button>
													<button mat-icon-button color="warn" (click)="deleteCommodity(row)">
														<mat-icon>delete</mat-icon>
													</button>
												}
											</td>
										</ng-container>

										<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
										<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
									</table>
								</div>
							</mat-card-content>
						</mat-card>
					</div>
				</mat-expansion-panel>
			</mat-dialog-content>
		</div>
	</ng-container>
	<ng-container>
		<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
			<div>
				<button (click)="close(false)" mat-raised-button type="button">
					<mat-icon>cancel</mat-icon>
					@if (!layoutService.isMobile()) {
						<span>
							{{ t('commonActions.cancel') }}
						</span>
					}
				</button>
				@if (!periodService.selectedPeriod().locked) {
					<button (click)="close(true)" color="primary" mat-raised-button type="submit">
						<mat-icon>check</mat-icon>
						@if (!layoutService.isMobile()) {
							<span>
								{{ t('common.apply') }}
							</span>
						}
					</button>
				}
			</div>
		</mat-dialog-actions>
	</ng-container>
</div>
